import React, { useState } from "react";
import { Link } from "react-router-dom";
import styles from "./contactUs.module.css";

const Contactus = () => {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
    newsletter: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({ ...form, [name]: type === "checkbox" ? checked : value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const scriptURL =
      "https://script.google.com/macros/s/AKfycbwELPSoPqjeZ-Js8zuUnfCD7S1qhizcKNzyaE5GlXyQuNdCF9Zx3Cwyu8XMUgFo1AyeSg/exec";

    try {
      await fetch(scriptURL, {
        method: "POST",
        mode: "no-cors",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(form),
      });

      alert("Your message has been submitted!");

      setForm({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        message: "",
        newsletter: false,
      });
    } catch (error) {
      console.error("Submit error:", error);
      alert("Something went wrong.");
    }
  };

  return (
    <div className={styles.contactWrapper}>
      <div className={styles.contactContainer}>
        <div className={styles.contactCard}>
          <div className={styles.infoCard}>
            <h2>Contact Us</h2>

            <p className={styles.contactInfo1}>📞 +91 8639904313</p>

            <Link
              className={styles.contactInfo}
              onClick={() =>
                window.open("https://www.instagram.com/tedxiitguwahati/", "_blank")
              }
            >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png"
                alt="Instagram"
                style={{ width: "20px", height: "20px" }}
              />
              tedxiitguwahati
            </Link>

            <Link
              className={styles.contactInfo}
              onClick={() => (window.location.href = "mailto:iitg.tedx@gmail.com")}
            >
              ✉ iitg.tedx@gmail.com
            </Link>

            <p className={styles.contactInfo1}>📍 IIT Guwahati</p>
          </div>

          <div className={styles.formContent}>
            <h1>Leave Us a Message</h1>
            <p>We’d love to hear from you! Fill out the form below.</p>

            <form onSubmit={handleSubmit}>
              <div className={styles.row}>
                <input
                  type="text"
                  name="firstName"
                  placeholder="First Name*"
                  required
                  value={form.firstName}
                  onChange={handleChange}
                />

                <input
                  type="text"
                  name="lastName"
                  placeholder="Last Name"
                  value={form.lastName}
                  onChange={handleChange}
                />
              </div>

              <div className={styles.row}>
                <input
                  type="email"
                  name="email"
                  placeholder="Email Address*"
                  required
                  value={form.email}
                  onChange={handleChange}
                />

                <input
                  type="text"
                  name="phone"
                  placeholder="Contact Number*"
                  required
                  value={form.phone}
                  onChange={handleChange}
                />
              </div>

              <textarea
                name="message"
                rows="5"
                placeholder="Your Message..."
                value={form.message}
                onChange={handleChange}
                className={styles.text}
              ></textarea>

              <div className={styles.check}>
                <input
                  type="checkbox"
                  id="newsletter"
                  name="newsletter"
                  checked={form.newsletter}
                  onChange={handleChange}
                />
                <label htmlFor="newsletter">
                  Sign me up for the newsletter
                </label>
              </div>

              <button type="submit" className={styles.gradientBtn}>
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contactus;
